import React, { useCallback } from 'react';
import { Link } from 'react-router-dom';
import { useCashieringActions } from '../useCashiering';
import { useStateSelector } from '../../../../data/global/dataSelectors';
import { accountDetailsSelectors } from '../../../../data/global/selectors/admin/accountSelectors';
import { DefaultAccountDetails } from '@tradingblock/types';

export const FilterForAccount: React.FunctionComponent<{ accountId: number }> = ({ accountId }) => {
  const { search: onSearch, setPage, setType, setStatus } = useCashieringActions();
  const accountDetails = useStateSelector(s => accountDetailsSelectors.data(s, accountId));
  const { accountNumber, accountNames } = accountDetails || DefaultAccountDetails;
  const handleSetFilter = useCallback(
    (accountNumberValue: string) => {
      setPage(0);
      setType([]);
      setStatus([]);
      onSearch(accountNumberValue.trim());
      sessionStorage.removeItem('cashieringSearch');
    },
    [accountNumber]
  );
  return (
    <div className="screen-body-section">
      <Link to="/admin/cashiering" onClick={() => handleSetFilter(accountNumber || accountNames[0])}>
        View all entries for: {accountNumber || accountNames[0]} <i className="fal fa-filter" />
      </Link>
    </div>
  );
};
